import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AdminAlertsState } from '../types';

export const selectAdminAlerts = createFeatureSelector<AdminAlertsState>('adminAlerts');

export const selectAdminAlertsItems = createSelector(
  selectAdminAlerts,
  adminAlerts => adminAlerts.items,
);
